import { 
    GetScoreState as DLGetScoreState, 
    UpdateScore as DLUpdateScore, 
    UpdateScoreStyle as DLUpdateScoreStyle, 
    TriggerScoreNotification as DLTriggerScoreNotification 
} from './../DL/Score';

const GetScoreState = async () => {
    try {
        const response = await DLGetScoreState();
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible obtener la información del marcador. Inténtalo más tarde.' };
    }
};

const UpdateScore = async (payload) => {
    try {
        // Validación básica para evitar envíos vacíos si fuera necesario
        if (!payload || Object.keys(payload).length === 0) {
            return { success: false, message: 'No hay datos válidos para actualizar.' };
        }

        const response = await DLUpdateScore(payload);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al actualizar el marcador.' };
    }
};

const UpdateScoreStyle = async (payload) => {
    try {
        if (!payload) return { success: false, message: 'Faltan datos de estilo.' };

        const response = await DLUpdateScoreStyle(payload);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al aplicar los estilos.' };
    }
};

const TriggerScoreNotification = async (payload) => {
    try {
        if (!payload.type) {
            return { success: false, message: 'El tipo de notificación es obligatorio.' };
        }

        const response = await DLTriggerScoreNotification({
            type: payload.type,
            htmlContent: payload.htmlContent || '',
            durationSeconds: payload.durationSeconds || 8
        });

        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'No fue posible lanzar la notificación a la pantalla.' };
    }
};

// =========================================================================
// HELPERS DEL ADMIN PANEL (LÓGICA DE NOTIFICACIONES)
// =========================================================================

/**
 * Construye el payload HTML para un Gol y lo envía.
 * @param {string} playerName - Nombre del jugador que anotó.
 */
const SendGoalEvent = async (playerName) => {
    const htmlContent = `
        <div style="display: flex; align-items: center; gap: 10px; color: #ffffff;">
            <i class="bi bi-futbol" style="color: #22c55e; font-size: 1.2rem;"></i>
            <span style="font-size: 0.8rem; text-transform: uppercase;">⚽ ¡GOL DE</span>
            <span style="font-size: 1.1rem; font-weight: 900;">${playerName}!</span>
        </div>
    `;
    
    return await TriggerScoreNotification({ type: 'goal', htmlContent, durationSeconds: 9 });
};

/**
 * Construye el payload HTML para Tarjetas (Amarilla/Roja) y lo envía.
 * @param {string} playerName - Nombre del infractor.
 * @param {string} cardType - 'yellow' o 'red'.
 */
const SendCardEvent = async (playerName, cardType) => {
    const isRed = cardType === 'red';
    const colorHex = isRed ? '#ef4444' : '#facc15';
    const labelText = isRed ? 'Expulsión:' : 'Amonestación:';

    const htmlContent = `
        <div class="notification-content" style="width: 100%; display: flex; justify-content: center;">
            <div style="display: flex; align-items: center; gap: 10px;">
                <i class="bi bi-file-fill" style="color: ${colorHex}; font-size: 1.2rem; animation: bounce 1s infinite;"></i>
                <span style="font-size: 0.8rem; text-transform: uppercase; opacity: 0.8; font-weight: 600; letter-spacing: 1px;">${labelText}</span>
                <span style="font-size: 1.1rem; font-weight: 900; text-transform: uppercase;">${playerName}</span>
            </div>
        </div>
    `;

    return await TriggerScoreNotification({ type: cardType, htmlContent, durationSeconds: 8 });
};

/**
 * Construye el payload HTML para una Sustitución y lo envía.
 */
const SendSubstitutionEvent = async (outNum, outName, inNum, inName, durationSeconds = 6) => {
    const htmlContent = `
        <div class="notification-content" style="width: 100%; display: flex; justify-content: center;">
            <div style="display: flex; align-items: center; justify-content: center; gap: 15px; font-size: 0.875rem; font-weight: bold; text-transform: uppercase; width: 100%;">
                
                <div style="display: flex; align-items: center; gap: 5px;">
                    <span style="color: white; font-weight: 800; margin-right: 4px;">SALE</span>
                    <span style="color: #ef4444;">${outNum} - ${outName}</span>
                    <i class="bi bi-caret-down-fill" style="color: #ef4444; font-size: 1.1rem;"></i>
                </div>
                
                <span style="color: rgba(255,255,255,0.3); margin: 0 10px;">|</span>
                
                <div style="display: flex; align-items: center; gap: 5px;">
                    <i class="bi bi-caret-up-fill" style="color: #22c55e; font-size: 1.1rem;"></i>
                    <span style="color: #22c55e;">${inNum} - ${inName}</span>
                    <span style="color: white; font-weight: 800; margin-left: 4px;">ENTRA</span>
                </div>
                
            </div>
        </div>
    `;

    return await TriggerScoreNotification({ type: 'substitution', htmlContent, durationSeconds });
};

export { GetScoreState, UpdateScore, UpdateScoreStyle, TriggerScoreNotification, SendGoalEvent, SendCardEvent, SendSubstitutionEvent };